<template>
    <div class="filter-wrapper">
        <div class="filter-inner-container">

            <div class="filter-field-container">
                <div class="row">
                    <template v-for="(field,key) in searchField">

                        <template v-if="field.type=='checkbox' || field.type=='radio' || field.type=='select'">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-6">
                                <div class="form-group" >
                                    <label>{{field.label}}</label>
                                    <v-select v-model="search[key]" :options="getFieldsArray(field.field_infos)" label="label"
                                        multiple>
                                        <template slot="no-options">No user
                                            available</template>
                                    </v-select>
                                </div>
                            </div>
                        </template>

                        <template v-else-if="field.type=='daterange'">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-6">
                                <div class="form-group" >
                                    <label>{{field.label}} From</label>
                                    <div class="item">
                                        <Datepicker :input-class="'form-control'" :calendar-button="true" :clear-button="true"
                                            :use-utc="false" :calendar-button-icon="'fa-solid fa-calendar-days'"
                                            :format="customFormatter" v-model="search[key + '__start']"></Datepicker>
                                </div>
                            </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4 col-6">
                                <div class="form-group" >
                                    <label>{{field.label}} To</label>
                                    <div class="item">
                                        <Datepicker :input-class="'form-control'" :calendar-button="true" :clear-button="true"
                                            :use-utc="false" :calendar-button-icon="'fa-solid fa-calendar-days'"
                                            :format="customFormatter" v-model="search[key + '__end']"></Datepicker>
                                    </div>
                            </div>

                            </div>
                        </template>

                        <template v-else-if="field.type=='date'">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-6">
                                <div class="form-group" >
                                    <label>{{field.label}}</label>
                                    <Datepicker :input-class="'form-control'" :calendar-button="true" :clear-button="true"
                                        :use-utc="false" :calendar-button-icon="'fa-solid fa-calendar-days'"
                                        :format="customFormatter" v-model="search[key + '__start']"></Datepicker>
                                </div>
                            </div>
                            
                        </template>
                       
                        <template v-else-if="field.type=='selectcomponent'">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-6">
                                <div class="form-group" >
                                    <label>{{field.label}}</label>
                                    <div class="form-group item-select">
                                        <input type="hidden" :id="field.id" v-model="search[key]">
                                        <input type="text" class="form-control" :id="field.name"
                                            autocomplete="off" v-on:keyup="queryForKeywords($event, field.route,field.id)" />
                                        <span class="group-select">
                                            <span ref="genericSearch"
                                                @click="openComponent(field.route,field.moduleName,field.id,field.name)"><i
                                                    class="fa-solid fa-user-plus"></i></span>
                                            <span @click="clearComponent(search[key])"><i class="fa-solid fa-xmark"></i></span>
                                        </span>
                                        <ul class="dropdown_type" v-if="showDropdown==field.id">
                                            <li v-for="item in dropdownList" :key="item.id"
                                                @click="updateItem(item.id,item.name,field.id,field.name)">{{item.name}}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </template>

                        <template v-else>
                            <div class="col-lg-4 col-md-4 col-sm-4 col-6">
                                <div class="form-group">
                                    <label>{{field.label}}</label>
                                    <input type="text" class="form-control" :id="key" v-model="search[key]">
                                </div>
                            </div>
                        </template>

                    </template>
                </div>
            </div>
            <div class="filter-bottom-controls">
               
                <div class="filter-field-preset-button">
                    <button type="search" class="btn btn-success btn-sm" @click="callParent('search')">Search</button>
                    <button type="button" class="btn btn-secondary btn-sm ms-1"
                        @click="callParent('reset')">Reset</button>
                    <button type="button" class="btn btn-warning btn-sm ms-1"
                        @click="callParent('reset')">Cancel</button>
                </div>
              
            </div>

        </div>
    </div>

</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    import vSelect from "vue-select";
    export default {
        name: "search-view",
        components: {
            Datepicker,
            vSelect,
        },
        data() {
            return {
               
                showDropdown: false,
                searchField: [],
                search: {},
                dom_array: [],
                field_name:'',
                field_id:'',
            }
        },
        mounted() {
           this.dom_array = this.domArrayVariable;
            this.loadSerach();
        },
        methods: {
            loadSerach() {
                let fieldsInfo = require(`@/views/modules/ExpressionInterests/metaview/metajs/SearchView.js`);
                this.searchField = fieldsInfo.default.searchFieldsDef;
                const storedFilters = localStorage.getItem('filters');
                if (storedFilters) {
                    const filters = JSON.parse(storedFilters);
                    for (const key in filters) {
                        if (filters.hasOwnProperty(key)) {
                            var value = filters[key].value;
                            this.search[key] = filters[key].value
                            if (typeof value == 'object') {
                                this.selectedOptions= [];
                                for (let index = 0; index < value.length; index++) {
                                    let newvalue = value[index];
                                    this.search[key] = filters[key].newvalue
                                    var field_info = this.searchField[key];
                                if (field_info && field_info.field_infos !== undefined) {
                                    var field_info = field_info.field_infos;
                                        if (typeof field_info == 'string') {
                                            label = this.dom_array[field_info][newvalue];
                                        } else {
                                            var label = field_info[newvalue];
                                        }
                                        if (!this.selectedOptions.includes({ key: newvalue, label: label })) {
                                            this.selectedOptions.push({ key: newvalue, label: label });
                                            this.search[key] = this.selectedOptions
                                        }
                                    }
                                }
                            } else {
                                this.selectedOptions= [];
                                var field_info = this.searchField[key].field_infos;
                                if (field_info !== '' && typeof field_info != 'undefined') {
                                    if (typeof field_info == 'string') {
                                        label = this.dom_array[field_info][value];
                                    } else {
                                        var label = field_info[value];
                                    }
                                    if (!this.selectedOptions.includes({ key: value, label: label })) {
                                        this.selectedOptions.push({ key: value, label: label });
                                        this.search[key] = this.selectedOptions
                                    }
                                }
                            }
                        }
                    }
                }
                
            },
           
           
            callParent(action) {
                if (action == 'reset') {
                    this.search = {};
                }
                let searchFieldDef = this.searchField;

                var searches = {};
                const searchDatas = Object.entries(this.search);
                for (const [key, value] of searchDatas) {
                    var newvalue = value;
                    if (Array.isArray(value)) {
                        newvalue = value.map((item) => item.key);
                    }
                    var mainKey = key;

                    const keyParts = key.split('__');

                    if (keyParts.length != 1) {
                        var [mainKey, subKey] = keyParts;
                    }

                    let keys = '';
                    if(key == 'submited_on__start' || key == 'submited_on__end')
                    {
                        keys = 'submited_on';
                    }else{
                        keys = key;
                    }

                    searches[key] = {
                        key: key,
                        value: newvalue,
                        field_info: searchFieldDef[keys],
                        relationship: searchFieldDef[mainKey].relationship ?? '',
                    }
                }
                this.$emit('searchEvent', searches);
                this.$emit('openAction');
            },
            getFieldsArray(fielsinfo) {
                let fielsinfo2;
                if (typeof fielsinfo == 'string') {
                    fielsinfo2 = this.dom_array[fielsinfo];
                } else {
                    fielsinfo2 = fielsinfo;
                }

                const fielsinfo3 = Object.keys(fielsinfo2).map(key => {
                    return { key: key, label: fielsinfo2[key] };
                });
                return fielsinfo3
            },
            customFormatter(date) {
                return moment(date).format('DD/MM/yyyy');
            },
            openComponent(routeName, moduleName, field_id = null, field_name = null) {
                this.field_id = field_id;
                this.field_name = field_name;
                this.windowRef = window.open(`/popup?module=${routeName}&body=modal&callback=parentMethod&moduleName=${moduleName}`, "", "width=600,height=400,left=200,top=200");
                this.parentCompnent = routeName;
                this.windowRef.addEventListener('beforeunload', this.parentMethod);

            },
            parentMethod() {
                const module_name = this.parentCompnent.slice(0, -1);
                const parent_id = localStorage.getItem('parentid');
                const parent_name = localStorage.getItem('parentname');
                const parent_type = localStorage.getItem('parenttype');

                this.selectElement(module_name, parent_name, parent_id, parent_type);

                if (this.windowRef) {
                    this.windowRef.close();
                    this.windowRef = null;
                    this.$emit('close');
                }

                localStorage.removeItem('parentid');
                localStorage.removeItem('parentname');
                localStorage.removeItem('parenttype');

            },

            queryForKeywords(e, route, field_id = null) {
                const self = this;
                self.field_id = field_id;
                let searchData = e.target.value;
                //let relatedModule = route + 's';
                let relatedModule = route
                self.showDropdown = false;

                if (searchData.length > 1) {
                    axios.post(`api/modules/searchItem`, { 'data': searchData, 'relatedModule': relatedModule }).then(function (response) {
                        self.dropdownList = response.data;
                        self.showDropdown = field_id;
                    });
                } else {
                    self.showDropdown = false;
                    self.dropdownList = [];

                    if (searchData.length == 0) {
                        self.selectElement(route, '', '', '');
                    }

                }
            },
            updateItem(id, name, field_id,field_name) {
                this.field_name = field_name;
                this.field_id = field_id;
                this.showDropdown = false;
                const module_name = 'type';
                this.selectElement(module_name,name,id);
            },
            clearComponent(modulesLink) {
                const self = this;
                self.dropdownList = [];
                if (self.dropdownList.length == 0) {
                    self.selectElement(modulesLink, '', '', '');
                }
            },
            selectElement(moduleName, name = null, id = null, module = null) {
                const p_name = this.field_name;
                const p_name_el = document.getElementById(p_name);
                p_name_el.value = name;
                p_name_el.dispatchEvent(new Event('input'));

                const p_id = this.field_id;
                const p_id_el = document.getElementById(p_id);
                p_id_el.value = id;
                p_id_el.dispatchEvent(new Event('input'));
            },
        },
    }
</script>